import React from 'react'

import SeletorCliente from 'entity/Cliente/components/SeletorCliente'
import Equipamento from 'entity/Equipamento'

import DefaultEntityCrud from 'components/form/DefaultEntityCrud'
import FormContent from 'components/form/FormContent'
import TextInput from 'components/form/input/TextInput'
import SelectInput from 'components/form/input/SelectInput'
import FormRow from 'components/form/FormRow'


function EquipamentoFormInter(props) {
    return (
        <FormContent sx={{ p: 2 }}>
            <FormRow>
                <TextInput
                    sx={{ flex: 0.5 }}
                    name="sequencialIndex"
                    label="Código"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    type="number"
                    disabled
                />
                <SelectInput
                    sx={{ flex: 0.5 }}
                    name="status"
                    label="Status"
                    options={["ATIVO", "INATIVO"]}
                    required
                />
                <SeletorCliente
                    sx={{ flex: 2 }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    required
                />
            </FormRow>

            <FormRow>
                <TextInput
                    sx={{ flex: 0.5 }}
                    name="equipamento"
                    label="Equipamento"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    required
                />
                <TextInput
                    sx={{ flex: 0.5 }}
                    name="servico"
                    label="Serviço"
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </FormRow>
        </FormContent>
    )
}

export default function EquipamentoForm() {
    return (
        <DefaultEntityCrud
            title={"Cadastro de Equipamento"}
            EntityClass={Equipamento}
            routeForm={"_equipamento"}
            backRoute="consulta-equipamento"

            formActions={{ novoForm: false, salvarForm: true, sairForm: true }}
        >
            {(props) => <EquipamentoFormInter {...props} />}
        </DefaultEntityCrud>
    )
}
